import { FieldPath, UseFormReturn } from 'react-hook-form';
import { DatePicker, DatePickerProps } from 'components/atoms/DatePicker';

type Props<TFieldValues> = Pick<DatePickerProps<TFieldValues>, 'inputProps'> & {
  name: FieldPath<TFieldValues>;
  control: UseFormReturn<TFieldValues>['control'];
};

export const ReleasedAtDatepicker = <TFieldValues,>({
  name,
  control,
  inputProps,
}: Props<TFieldValues>) => (
  <DatePicker
    datePickerProps={{ minDate: new Date() }}
    controllerProps={{
      control,
      name,
      rules: {
        required: '必須項目です。',
      },
    }}
    inputProps={inputProps}
  />
);
